import type { JsonObject } from "@estelle/domain";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

/**
 * The channel's raw payload, pretty-printed (#55).
 *
 * `<details>` rather than a card that is simply open: a raw Shopify order
 * payload carries the customer's name, phone number and shipping address —
 * exactly the fields the Customer card in the sidebar already shows
 * politely. Rendering this expanded by default would put a second, blunter
 * copy of that same personal data on every monitor a support agent has this
 * screen open on, for every order, whether or not anyone asked to see it.
 * `<details>` defaults closed with no JavaScript required to keep it that
 * way, which a `useState(false)` toggle would not guarantee against a
 * future edit.
 */
export function OrderRawPayload({ raw }: { raw: JsonObject }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Raw payload</CardTitle>
      </CardHeader>
      <CardContent>
        <details>
          <summary className="text-muted-foreground cursor-pointer text-sm select-none">
            Show the channel's raw payload
          </summary>
          <pre className="bg-muted mt-2 max-h-96 overflow-auto rounded-md p-3 text-xs">
            {JSON.stringify(raw, null, 2)}
          </pre>
        </details>
      </CardContent>
    </Card>
  );
}
